var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name === _vm.names.FIELDS.DETAIL)?_c('v-container',{staticClass:"page-content px-sm-5",staticStyle:{"margin":"0px","width":"100%"}},[(_vm.field_detail)?[_vm._v(" "+_vm._s(_vm.field_detail)+" ")]:[_vm._v(" Опрос не найден ")]],2):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }